export default __webpack_public_path__ + "static/media/health_information_header.7a71a263.svg";